import React from 'react'

import { AppInTerminalAutocomplete } from "@components"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { BACKEND_APIS } from "@constants"

export default function AlertsAirportLocation() {

	const {
		dataInfo, setDataInfo
	} = useAlertsDataInfo(alertsDrawerData.peek().airportLocation)

	return <AppInTerminalAutocomplete
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/terminal`}
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'airportLocation')}
	/>
}
